var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"employee-search"},[_c('Autosuggest',{attrs:{"model":_vm.searchEmployee,"suggestions":_vm.filteredEmployees,"placeholder":_vm.placeholder,"limit":_vm.limit,"disabled":_vm.disabled,"suggestionName":"suggestionName"},on:{"select":_vm.onSelectedEmployee,"change":_vm.onSearchEmployeeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }